module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"status:true":"Работает","status:false":"Ошибка"},"en":{"status:true":"Working","status:false":"Error"}}')
  delete Component.options._Ctor
}
